import AutoHeight from 'embla-carousel-auto-height';
import EmblaCarousel from 'embla-carousel';

// ℹ️ if you need styling and not functionality, don't use '.tabs' class
const tabsElements = document.querySelectorAll('.tabs');

const tabNavigationItem = 'tabs__navigation-item';
const tabNavigationActive = `${tabNavigationItem}--active`;
const scrollOverflow = 'scroll-overflow';
const excludeEffects = ['tabs--filters'];

// sliders
let tabsNavigation;
let tabsPanels;

const thumbsClickHandlers = () => {
  const slidesThumbs = tabsNavigation?.slideNodes();

  if (slidesThumbs != null) {
    const scrollToIndex = slidesThumbs.map(
      (_, index) => () => tabsPanels.scrollTo(index),
    );

    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener('click', scrollToIndex[index], false);
    });
  }
};

const toggleTabActiveAnimation = () => {
  const slides = tabsNavigation?.slideNodes();

  if (slides == null) {
    return;
  }

  const activeSlide =
    slides.findIndex((slide) =>
      slide.classList.contains(tabNavigationActive),
    ) ?? 0;

  // handle transition classes based on slide direction
  slides.forEach((slide, index) => {
    slide.classList.remove(`${tabNavigationItem}--before`);
    slide.classList.remove(`${tabNavigationItem}--after`);

    if (activeSlide > index) {
      slide.classList.add(`${tabNavigationItem}--after`);
    } else {
      slide.classList.add(`${tabNavigationItem}--before`);
    }
  });
};

const toggleThumbsState = () => {
  const slidesThumbs = tabsNavigation.slideNodes();

  tabsNavigation.scrollTo(tabsPanels.selectedScrollSnap());
  const previous = tabsPanels.previousScrollSnap();
  const selected = tabsPanels.selectedScrollSnap();
  slidesThumbs[previous].classList.remove(tabNavigationActive);
  slidesThumbs[selected].classList.add(tabNavigationActive);

  toggleTabActiveAnimation();
};

const toggleScrollGradient = () => {
  const tabsNavigationRoot = tabsNavigation.rootNode();

  if (!tabsNavigationRoot.classList.contains(scrollOverflow)) {
    return;
  }

  const tabsNotInView = tabsNavigation.slidesNotInView();
  const slidesAtStart = tabsNotInView.includes(0);
  const slidesAtEnd = tabsNotInView.includes(
    tabsNavigation.slideNodes().length - 1,
  );

  if (slidesAtEnd) {
    tabsNavigationRoot.classList.add(`${scrollOverflow}--end`);
  } else {
    tabsNavigationRoot.classList.remove(`${scrollOverflow}--end`);
  }

  if (slidesAtStart) {
    tabsNavigationRoot.classList.add(`${scrollOverflow}--start`);
  } else {
    tabsNavigationRoot.classList.remove(`${scrollOverflow}--start`);
  }
};

const bringInViewport = () => {
  let activeSlide = 0;

  // special case for when in BEF filters
  // if needed more variety maybe expand classes we're looking for
  const slides = tabsNavigation?.slideNodes();
  activeSlide = slides?.findIndex((slide) => {
    return slide.firstElementChild.classList.contains('bef-link--selected');
  });
  if (activeSlide) {
    tabsNavigation.scrollTo(activeSlide);
  }
};

const initTabs = (tabs = []) => {
  const limitedFunctionality = [...tabs.classList].some((c) =>
    excludeEffects.includes(c),
  );
  // reset
  tabsPanels = null;
  tabsNavigation = null;

  const tabsPanelViewport = tabs.querySelector('.tabs__panels-viewport');
  if (tabsPanelViewport) {
    let panelOptions = {};
    const panelPlugins = [];

    // Disable draggable state for panels.
    if (tabsPanelViewport.classList.contains('tabs__panels-no-drag')) {
      panelOptions = { ...panelOptions, watchDrag: false };
    }

    if (!tabsPanelViewport.classList.contains('tabs__panels-no-auto-height')) {
      panelPlugins.push(AutoHeight());
    }

    tabsPanels = EmblaCarousel(tabsPanelViewport, panelOptions, panelPlugins);
  }

  const tabsNavigationViewport = tabs.querySelector(
    '.tabs__navigation-viewport',
  );
  if (tabsNavigationViewport) {
    tabsNavigation = EmblaCarousel(tabsNavigationViewport, {
      breakpoints: {
        '(min-width: 0px)': {
          watchDrag: true,
        },
        '(min-width: 1181px)': {
          watchDrag: !limitedFunctionality,
        },
      },
      containScroll: 'trimSnaps',
      // make sure most of the link is visible
      inViewThreshold: 0.99,
    });
  }

  // only continue if we need whole tabs functionality
  // (for ex. we don't on Product catalog filters)
  if (!limitedFunctionality) {
    // add click events
    thumbsClickHandlers();

    if (tabsPanels) {
      tabsPanels.on('select', toggleThumbsState);
    }
    if (tabsNavigation) {
      tabsNavigation
        .on('init', toggleThumbsState)
        .on('settle', toggleScrollGradient);
    }
  }

  // makes sure the active tab is visible
  bringInViewport();
};

(() => {
  if (tabsElements.length) {
    tabsElements.forEach((tabs) => initTabs(tabs));
  }
})();

if (tabsElements.length) {
  window.addEventListener('resize', () => {
    // make sure the active tab is in viewport
    bringInViewport();
  });
}
